import React from "react";
import { BackstageChatHeader } from "./BackstageChatHeader";
import { ChatFooter } from "./ChatFooter";
import { ChatHeader } from "./ChatHeader";
import { MessageList } from "./MessageList";
import { ScrollToBottomButton } from "./ScrollToBottomButton";

export function ChatContainer(props) {
  const { autoScrollLocked, currentChat, backstage, chatTemplate, chatBlock, anonymous, eventId, parentEventId } = props;

  const { collapsible, hideFooter, hideHeader } = props.settings;
  const { container } = chatTemplate;
  const { borderRadius, borderColor, borderWidth } = container;

  return (
    <div
      className="chat-container"
      style={{
        border: `1px solid ${borderColor}`,
        borderWidth,
        borderColor,
        zIndex: -1,
        borderRadius,
        position: "relative",
        overflow: "hidden",
        display: "flex",
        flexDirection: "column",
        background: "none",
      }}
    >
      {!hideHeader && <>{!backstage ? <ChatHeader {...props} /> : <BackstageChatHeader {...props} />}</>}
      {autoScrollLocked && currentChat == "ALL" && !(parentEventId == 1427 || eventId == 1427) ? <ScrollToBottomButton {...props} /> : null}
      <MessageList {...props} />
      {!chatBlock && anonymous != true && !hideFooter ? <ChatFooter {...props} /> : null}
    </div>
  );
}
